module.exports = __webpack_public_path__ + "static/img/feature-2.271151a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mss/feature-2.png
// module id = fpSe
// module chunks = 1